import React from 'react';
import './Contact.css';
import ContactForm from './ContactForm';

function Contact() {
  return (
    <section id="contact" className="contact">
      <div className="container">
        <h2 className="section-title">Contact Us</h2>
        <p className="section-subtitle">Get in touch with us for any queries or to schedule a consultation</p>
        <div className="contact-content">
          <div className="contact-info">
            <div className="info-item">
              <img src="/assets/mail.svg" alt="" className="info-icon" />
              <div>
                <h3>Email</h3>
                <p>info@dhrey.com</p>
              </div>
            </div>
            <div className="info-item">
            <img src="/assets/phone.svg" alt="" className="info-icon" />
              <div>
                <h3>Phone</h3>
                <p>+91-8431976479</p>
              </div>
            </div>
            <div className="info-item">
            <img src="/assets/map-pin.svg" alt="Location" className="info-icon" />
              <div>
                <h3>Location</h3>
                <p> 25/4-2/316-TF-C133,</p>
                <p>Guru Sarva Bhoma Nagara, Nayandahalli,</p>
                <p>Bangalore, Bangalore South, </p> 
                <p>Karnataka, India </p><p>560039</p>
              </div>
            </div>
          </div>
          <div className="contact-form-wrapper">
            <ContactForm />
          </div>
        </div>
      </div>
    </section>
  );
}

export default Contact;

